import {Divider, Image} from "antd";
import {images_folder} from "./client";
import React from "react";
import {Footer} from "antd/es/layout/layout";

const SiteFooter = () => {
    return (
        <Footer style={{textAlign: 'center'}}>
            <Image
                width={75}
                preview={false}
                src={images_folder("princess-obome-helping-hand-logo.png")}
            />
            <Divider>
                <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://princessobomefoundation.org">
                    Copyright &copy; Princess Obome Foundation
                </a>
                <p style={{'color':'#999'}}>5161 Lankershim Blvd, Suite 250<br/>North Hollywood, CA 91601</p>
                <p><a href="https://princessobomefoundation.org/privacy-policy"  rel="noreferrer" target="_blank">Privacy Policy</a> | <a  rel="noreferrer" href="https://princessobomefoundation.org/terms-of-service" target="_blank">Terms of Service</a></p>
            </Divider>
        </Footer>
    );
};

export default SiteFooter;